// extracted by mini-css-extract-plugin
module.exports = {"tile":"NestedRow_tile__w9oD_","name":"NestedRow_name__2K7yH"};